module.exports = __webpack_public_path__ + "static/media/undraw_robotics_kep0.468163ae.svg";